import React, { useState } from "react";

const Tab = (props) => {
  const [toggele, setToggele] = useState(1);
  const toggeleTab = (index) => {
    setToggele(index);
    return props.panelData(index)
  };
 
  return (
          <center>
    <div className=" relative  my-6  mt-8 ">
      <div className="mx-auto mb-6 flex max-w-xl space-x-[44px] justify-center flex-row md:space-x-[244px]">
        {props.panel1 && (
          <div className="flex h-[52px]  cursor-pointer justify-center text-center text-[32px]  dark:text-[#FFFFFF]  md:w-1/3 md:border-b-0 ">
            <div
              className={toggele === 1 ? "border-b-4 border-[#17A6DB] dark:border-[#30dada] text-[#17A6DB]  dark:text-[#30dada]" : " "}
              onClick={(e) => toggeleTab(1)}

            >
              {props.panel1}
            </div>
          </div>
        )}



        {/* <!-- Tab 2 --> */}
        {props.panel2 && (
          <div className="flex h-[52px] cursor-pointer justify-center text-center text-[32px]  dark:text-[#FFFFFF]  md:w-1/3 md:border-b-0 ">
            <div
              className={toggele === 2 ? "border-b-4 border-[#17A6DB] dark:border-[#30dada]  text-[#17A6DB]  dark:text-[#30dada]" : " "}
              onClick={(e) => toggeleTab(2)}
            >
              {props.panel2}
            </div>
          </div>
        )}


        {/* <!-- Tab 3 --> */}
        {props.panel3 && (
          <div className="flex h-[52px] cursor-pointer justify-center text-center text-[32px]  text-[#FFFFFF]  md:w-1/3 md:border-b-0 ">
          <div
              className={toggele === 2 ? "border-b-4 border-[#17A6DB] dark:border-[#30dada]  text-[#17A6DB]  dark:text-[#30dada]" : " "}
              onClick={(e) => toggeleTab(2)}
            >
              {props.panel3}
            </div>
          </div>
        )}
      </div>
    </div>
    </center>
  );
};

export default Tab;
